import { render, staticRenderFns } from "./DestinationWhatsHappening.vue?vue&type=template&id=f4a4c1ce&scoped=true&"
import script from "./DestinationWhatsHappening.vue?vue&type=script&lang=js&"
export * from "./DestinationWhatsHappening.vue?vue&type=script&lang=js&"
import style0 from "./DestinationWhatsHappening.vue?vue&type=style&index=0&id=f4a4c1ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a4c1ce",
  null
  
)

export default component.exports